import { ArticlePV } from './../../models/API';
import { useAPI } from './useAPI';

const initData: ArticlePV = {};

export const useArticlePvAPI = (articles: Array<{ id: number }>, inputs: any[] = []) => {
    const ids: string = articles.map(a => a.id).join(',');
    return useAPI<ArticlePV>(`//v2.sohu.com/public-api/articles/pv?articleIds=${ids}`, initData, inputs, !articles.length);
};



// WEBPACK FOOTER //
// ./src/hooks/APIs/useArticlePvAPI.ts